import React from 'react';
import { BarLoader } from 'react-spinners';
import Theme from 'App.theme';
import { PageSpinnerContainer } from './PageSpinner.styles';

const PageSpinner: React.FC = ({ ...rest }) => {
  return (
    <PageSpinnerContainer {...rest}>
      <BarLoader color={Theme.colours.primary} />
    </PageSpinnerContainer>
  );
};

export default PageSpinner;
